import React, { FC } from 'react';
import { LoadingButton } from '@mui/lab';
import { Stack, Typography } from '@mui/material';
import Modal from 'molecules/Modal';
import {
  ModalActions,
  ModalCloseButton,
  ModalContent,
} from 'molecules/Modal/Modal.styles';
import { currencyFormatter } from 'utils/helpers/currencyFormatter';
import { formatGCPUsageMonth } from '../status';
import { GCPBillingDataRow } from '../types';

interface ResendInvoiceDialogProps {
  row: GCPBillingDataRow | null;
  resendingId: string | null;
  onClose: () => void;
  onConfirm: () => void;
}

const valueOrDash = (value?: string) => value || '—';

const ResendInvoiceDialog: FC<ResendInvoiceDialogProps> = ({
  row,
  resendingId,
  onClose,
  onConfirm,
}) => {
  if (!row) return null;

  const amount =
    typeof row.total_amount === 'number' && row.currency
      ? currencyFormatter(row.total_amount, row.currency)
      : '—';
  const isLoading = resendingId === row.id;

  return (
    <Modal
      open
      maxWidth="sm"
      title="Trigger Invoice Creation"
      onClose={onClose}
    >
      <>
        <ModalContent>
          <Stack spacing={1} sx={{ py: 2 }}>
            <Typography>{`Company: ${valueOrDash(
              row.company_name
            )}`}</Typography>
            <Typography>{`GCP Billing ID: ${valueOrDash(
              row.gcp_billing_id
            )}`}</Typography>
            <Typography>{`Usage Month: ${formatGCPUsageMonth(
              row.usage_month
            )}`}</Typography>
            <Typography>{`Currency: ${valueOrDash(row.currency)}`}</Typography>
            <Typography>{`Total Amount: ${amount}`}</Typography>
          </Stack>
        </ModalContent>
        <ModalActions>
          <ModalCloseButton
            variant="outlined"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </ModalCloseButton>
          <LoadingButton
            variant="contained"
            loading={isLoading}
            disabled={isLoading}
            onClick={onConfirm}
          >
            Trigger Invoice Creation
          </LoadingButton>
        </ModalActions>
      </>
    </Modal>
  );
};

export default ResendInvoiceDialog;
